import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { optimizedImage, fallbackToOriginal } from '../utils/imageUrl';
const MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/wVyuNdyu6KZi89Arcrndgk/BIBLIA_TRADICIONAL_(5).png';
const ITEMS = [{
  emoji: '📕',
  title: 'La Biblia en Cómic completa en PDF',
  text: 'Más de 200 páginas a todo color, de Génesis a Apocalipsis.'
}, {
  emoji: '📱',
  title: 'Formato universal',
  text: 'Se lee en celular, tablet, computadora o Smart TV.'
}, {
  emoji: '🖨️',
  title: 'Permiso de impresión doméstica',
  text: 'Imprímela y encuadérnala para regalar (ideal abuelos).'
}, {
  emoji: '♾️',
  title: 'Acceso de por vida',
  text: 'Descárgala las veces que quieras, sin vencimiento.'
}];
const BONUSES = [{
  emoji: '🔎',
  title: 'Sopa de letras de la Biblia',
  text: 'Juegos para repasar personajes e historias en familia.'
}, {
  emoji: '📖',
  title: '25 enseñanzas divinas para niños',
  text: 'Lecciones cortas y claras para conversar después de leer.'
}, {
  emoji: '🙏',
  title: '30 días de oración con el Pentateuco',
  text: 'Un versículo y una oración para cada día del mes.'
}];
export function WhatYouGetSection() {
  return <section className="w-full bg-cream" data-id="element-198" data-mp="253g0k6f0oz8a">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-199" data-mp="252d65oihkenm">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[40px]" data-id="element-200" data-mp="18dykcxierusc">
          Todo esto llega a tu email en menos de{' '}
          <span className="mark-gold" data-id="element-201" data-mp="1hd23u2lhmc7d">2 minutos</span>
        </h2>

        <div className="mt-6 grid grid-cols-1 items-center gap-6 md:grid-cols-2" data-id="element-202" data-mp="1hbqyvzgb2yeo">
          <motion.img initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} src={optimizedImage(MOCKUP_SRC, 800)} onError={event => fallbackToOriginal(event, MOCKUP_SRC)} alt="La Biblia en Cómic en versión impresa y digital en tablet" width={1080} height={1080} loading="lazy" decoding="async" sizes="384px" className="mx-auto h-auto w-full max-w-sm drop-shadow-2xl" data-id="element-203" data-mp="1m5lkx9jdvpgx" />

          <ul className="space-y-4" data-id="element-204" data-mp="21rzoovdz1iln">
            {ITEMS.map((item, i) => <motion.li key={item.title} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.45,
            delay: i * 0.08
          }} className="flex items-start gap-4 rounded-card border border-card-border bg-white p-4 shadow-soft" data-id="element-205" data-mp="1e0azhnwg5a8x" data-mpi={i}>
                <span className="text-2xl" aria-hidden="true" data-id="element-206" data-mp="2ye2y8juvvroc">
                  {item.emoji}
                </span>
                <div data-id="element-207" data-mp="2ugnbivedcg1b">
                  <h3 className="font-display text-lg font-bold text-deep-blue" data-id="element-208" data-mp="31y3cp4wm5mg9">
                    {item.title}
                  </h3>
                  <p className="text-[15px] text-ink/70" data-id="element-209" data-mp="36xob9e7vfssg">{item.text}</p>
                </div>
              </motion.li>)}
          </ul>
        </div>

        <div className="mt-8 rounded-card border-2 border-gold bg-white p-6" data-id="element-210" data-mp="2wygz2ucvi46x">
          <div className="text-center" data-id="element-211" data-mp="2x0jz877qpdpd">
            <span className="inline-block rounded-full bg-gold px-3 py-1 text-[12px] font-bold uppercase tracking-wide text-deep-blue" data-id="element-212" data-mp="3ko1krl0evfjw">
              Solo por hoy · Bonus de regalo
            </span>
            <h3 className="mt-3 font-display text-2xl font-bold text-deep-blue" data-id="element-213" data-mp="3az9udhb013b3">
              Y además te llevas 3 regalos gratis
            </h3>
          </div>

          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-214" data-mp="7hrq1jufqeff">
            {BONUSES.map((bonus, i) => <motion.div key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.45,
            delay: i * 0.08
          }} className="rounded-card border border-card-border bg-cream p-4 text-center" data-id="element-215" data-mp="c886zdxgsi6j" data-mpi={i}>
                <span className="text-2xl" aria-hidden="true" data-id="element-216" data-mp="2at7ryzs26psx">
                  {bonus.emoji}
                </span>
                <h4 className="mt-1 font-display text-[17px] font-bold leading-snug text-deep-blue" data-id="element-217" data-mp="33fsi5wwssvuw">
                  {bonus.title}
                </h4>
                <p className="mt-1 text-[14px] leading-snug text-ink/70" data-id="element-218" data-mp="2yhh75iurofb3">
                  {bonus.text}
                </p>
                <p className="mt-2 text-[13px] font-bold uppercase tracking-wide text-gold" data-id="element-219" data-mp="2tnwabu4wtrdh">
                  Gratis hoy
                </p>
              </motion.div>)}
          </div>

          <p className="mt-5 text-center text-[15px] font-semibold text-deep-blue" data-id="element-220" data-mp="3m8ecudvyygdw">
            Los tres bonus valen{' '}
            <span className="text-ink/50 line-through" data-id="element-221" data-mp="3por046fq80u9">USD 11,99</span> — hoy los
            recibes sin costo. Ahorras{' '}
            <span className="mark-gold" data-id="element-222" data-mp="3tr40efbpf6jn">USD 11,99 solo por hoy</span>.
          </p>
        </div>

        <div className="mt-6" data-id="element-223" data-mp="2iq6lre5pyjw">
          <CtaButton label="QUIERO MI BIBLIA EN CÓMIC" size="lg" data-id="element-224" data-mp="2igh04x0xteq" />
        </div>
      </div>
    </section>;
}